export const getViverseAndroidAppUrl = () =>
  'https://play.google.com/store/apps/details?id=com.viverse.app.mobile&referrer=utm_source%3Dwebsite%26utm_medium%3Dbutton%26utm_campaign%3Dwebsite_download_popup'

export const getViverseIosAppUrl = () =>
  'https://apps.apple.com/app/apple-store/id6739860362?pt=96176905&ct=website_download_popup&mt=8'
